import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { countryMapValidation } from '../constants/ContentConstats';

export const useIsCountryMatch = (): boolean => {
  const { country } = useParams();

  const envCountry = useMemo(() => {
    const raw = countryMapValidation[country as string]; // usa NEXT_PUBLIC_ para exponerlo en cliente
    return raw; // elimina la pleca y asegura minúsculas
  }, [country]);

  return country === envCountry;
};
